import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import type { BlockField } from '@/blocks/domain/types';
import type { LayersRowMenuItem } from '@/common/presentation/components/layers';
import type { CanvasStructureApi } from './CanvasStructureContext';

/** The selected element's ⋮ menu: Duplicate, Move up, Move down, Delete (settings is its own tool). */
export function useCanvasElementMenu(api: CanvasStructureApi, field: BlockField, name: string): LayersRowMenuItem[] {
  const testId = (action: string) => `document-render:selectable-element:${field.id}:menu-${action}`;
  return [
    {
      label: 'Duplicate',
      icon: <ContentCopyIcon fontSize="small" />,
      onClick: () => api.duplicateElement(field.id),
      testId: testId('duplicate')
    },
    {
      label: 'Move up',
      icon: <ArrowUpwardIcon fontSize="small" />,
      onClick: () => api.moveElementBy(field.id, -1),
      disabled: !api.canMoveElementBy(field.id, -1),
      testId: testId('move-up')
    },
    {
      label: 'Move down',
      icon: <ArrowDownwardIcon fontSize="small" />,
      onClick: () => api.moveElementBy(field.id, 1),
      disabled: !api.canMoveElementBy(field.id, 1),
      testId: testId('move-down')
    },
    {
      label: `Delete ${name}`,
      icon: <DeleteOutlineIcon fontSize="small" />,
      onClick: () => api.removeElement(field.id),
      destructive: true,
      testId: testId('delete')
    }
  ];
}
